"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.withSetGenericSearchValue = exports.withGenericSearchValue = void 0;

var _recompose = require("@hypnosphi/recompose");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var initialState = function initialState(_ref) {
  var searchCriteria = _ref.searchCriteria;
  return (searchCriteria.keywords || []).join(' ');
};

var withGenericSearchValue = (0, _recompose.withState)('genericSearchValue', 'setGenericSearchValue', initialState);
exports.withGenericSearchValue = withGenericSearchValue;

var stringFromEvent = function stringFromEvent(event) {
  return (event && event.target ? event.target.value : event) || '';
};

var handleGenericSearchValueChange = function handleGenericSearchValueChange(_ref2) {
  var setGenericSearchValue = _ref2.setGenericSearchValue;
  return function (event) {
    var genericSearchValue = stringFromEvent(event);
    setGenericSearchValue(genericSearchValue);
  };
};

var withSetGenericSearchValue = (0, _recompose.withHandlers)({
  handleGenericSearchValueChange: handleGenericSearchValueChange
});
exports.withSetGenericSearchValue = withSetGenericSearchValue;
var withPropTypes = (0, _recompose.setPropTypes)({
  searchCriteria: _propTypes["default"].object.isRequired
});

var _default = (0, _recompose.compose)(withPropTypes, withGenericSearchValue, withSetGenericSearchValue);

exports["default"] = _default;